export enum AlternateContact {
   arbitration = 'alternateArbitration'
};
